import makeBooleanWidget from './makeBooleanWidget';
import CheckboxInput from '../../Inputs/CheckboxInput/CheckboxInput';
export default makeBooleanWidget(CheckboxInput);